export interface Category {
    id: number;
    name: string;
    age_start: number;
    age_end: number;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyCategory: Category = {
    id: 0,
    name: '',
    age_start: 0,
    age_end: 0,
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}